import { useState } from 'react';

import type { SavedScheduleResult } from '../../../../../../apis/campaignGraphqlManager/customPacing/types';
import type { Maybe } from '../../../../../../apis/graphql';

export type UseCustomPacingDataResult = {
  savedScheduleResult: Maybe<SavedScheduleResult>;
  setSavedScheduleResult: (data: SavedScheduleResult) => void;
};

const useCustomPacingData = (): UseCustomPacingDataResult => {
  const [savedScheduleResult, setSavedScheduleResult] = useState<Maybe<SavedScheduleResult>>(null);

  return {
    savedScheduleResult,
    setSavedScheduleResult,
  };
};

export default useCustomPacingData;
